import React, { useEffect, useState } from "react";
import { Commet } from "react-loading-indicators";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen mx-auto">
      <Commet color="#FF6C6C" size="large" text="" textColor="" />
    </div>
  );
};

export default Loader;
